import {
  nameOnCardValidation,
  fullNameValidation,
} from './nameOnCardValidation';
import ccNumAndCvcValidation from './ccNumAndCvcValidation';
import ccExpirationValidation from './ccExpirationValidation';
import {
  phoneValidation,
  street1Validation,
  cityValidation,
  stateValidation,
  postalCodeValidation,
} from './addressValidations';

const billingAddressValidations = (
  distinctBillingAddress,
  { city, phoneNumber, postalCode, state, street1, fullName }
) => {
  if (!distinctBillingAddress) {
    return null;
  }

  return {
    ...phoneValidation(phoneNumber),
    ...street1Validation(street1),
    ...cityValidation(city),
    ...stateValidation(state),
    ...postalCodeValidation(postalCode),
    ...fullNameValidation(fullName),
  };
};

const CreditCardInfoFormValidations = ({
  creditCardNumber,
  ccSecurityCode,
  nameOnCard,
  expirationMonth,
  expirationYear,
  distinctBillingAddress,
  billingAddress,
}) => ({
  ...ccNumAndCvcValidation(creditCardNumber, ccSecurityCode),
  ...nameOnCardValidation(nameOnCard),
  ...ccExpirationValidation(expirationMonth, expirationYear),
  billingAddress: billingAddressValidations(
    distinctBillingAddress,
    billingAddress || {}
  ),
});

export default CreditCardInfoFormValidations;



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/creditCardInfoFormValidation.js